import React, { Component } from "react";
import * as d3 from 'd3';
// import ReactDOM from "react-dom";
import SideBySideView from "./SideBySideView";
import Table from "./Table";
// import {style} from "d3";
import TableTwoModels from "./TableTwoModels";


class TwoModelsGridExtended extends Component {

    constructor(props) {
        super(props);
        this.state = {
            highlighted_model: "",
            intersection_color: "#70ba6c",
            src: this.props.passage["src"],
            tgt: this.props.passage["tgt"],
            gs: this.props.passage["gs"],
            model2_name: this.props.model2_name,
            model1_name: this.props.model1_name,
            selected_view: "grid",
            gs_pv_checked: false
        }
    }

    setSelectedView = (view)=>{
        this.setState({
            selected_view: view
        })
    }

    set_model2 = (model2_name)=>{
        this.setState({
            model2_name: model2_name
        }, ()=>{
            this.drawGrid();
        })

    }

    componentDidMount() {
        this.drawGrid();
        this.drawBarChart();
        // this.visualize_text();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.model2_name!==prevProps.model2_name || this.props.model1_name!==prevProps.model1_name){
            this.setState({
                model2_name: this.props.model2_name,
                model1_name: this.props.model1_name
            })
        }


        this.drawGrid();
        this.drawBarChart();
        // this.visualize_text();
    }

    drawGrid = ()=>{
        const {model1_name, colors, search_term, search_term_language} = this.props
        const {model2_name, src, tgt, gs, intersection_color} = this.state
        const model1 = this.props.passage[model1_name]
        const model2 = model2_name===null?null:this.props.passage[model2_name]
        // set the dimensions and margins of the graph
        // const node = ReactDOM.findDOMNode(this);
        //const divWidth = node.getBoundingClientRect().width-20;
        let src_longest_token = Math.max(...src.map(x=>{return x.length}))
        // console.log(src_longest_token)

        var x_p = 2;
        var y_p = 2;
        var x_margin = 5+ src_longest_token*6.1
        var y_margin = 60
        var cell_width = 16
        var cell_height = 16


        const divHeight = src.length*(cell_height + y_p) + 2*y_margin;
        const divWidth = tgt.length*(cell_height + x_p) + 2*x_margin;
        var margin = {top: 5, right: 0, bottom: 30, left: 0},
            width = divWidth - margin.left - margin.right,
            height = divHeight - margin.top - margin.bottom;

        var default_cell_color = "#DDD"
        var default_text_color = "#333"

        // append the svg object to the body of the page
        d3.select("#sentenceChart_"+this.props.idx).select("svg").remove();
        var svg = d3.select("#sentenceChart_"+this.props.idx)
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");

        let parent = this;

        // create a tooltip
        var Tooltip = d3.select("#sentenceChart_"+this.props.idx)
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")
            .style("background-color", "white")
            .style("border", "solid")
            .style("border-color", "#AAA")
            .style("border-width", "1px")
            .style("border-radius", "3px")
            .style("padding", "3px")

        // Three function that change the tooltip when user hover / move / leave a cell
        var mouseover = function(d, src_id, tgt_id) {
            var text = src[src_id] + " = " + tgt[tgt_id]
            Tooltip
                .style("opacity", 1)
                .html(text)
                .style("left", (d.x +10)+ "px")
                .style("top", d.pageY+ "px");


            d3.select("#src_"+ parent.props.idx +"_" + src_id)
                .style("fill", "red")
            d3.select("#tgt_"+ parent.props.idx +"_" + tgt_id)
                .style("fill", "red")

        }
        var mouseleave = function(d, src_id, tgt_id) {
            Tooltip
                .style("opacity", 0)

            d3.select("#src_"+ parent.props.idx +"_" + src_id)
                .style("fill", default_text_color)
            d3.select("#tgt_"+ parent.props.idx +"_" + tgt_id)
                .style("fill", default_text_color)
        }

        src.map((t, i) => {
            svg.append('text')
                .attr("x", x_margin-5)
                .attr("y", margin.top + cell_height * 0.75 + i * (cell_height + y_p))
                .attr("fill", ()=>{return (search_term_language==="src" && t===search_term)? '#F33':"#333"})
                .attr("id", "src_"+ this.props.idx +"_"  + i)
                .text(t)
                .style("font-size", "10px")
                .style('text-anchor', 'end')
                .style('font-weight', ()=>{return (search_term_language==="src" && t===search_term)? '700':''});

            tgt.map((s, ii) => {

                svg.append('rect')
                    .attr('x', x_margin + ii * (cell_width + x_p))
                    .attr('y', margin.top + i * (cell_height + y_p))
                    .attr('translation_pair', t + " = " + s)
                    .attr('width', cell_width)
                    .attr('height', cell_height)
                    .attr('fill', default_cell_color)
                    .attr('id', "cell_" + this.props.idx +"_"  + i + "_" + ii)
                    .attr("src_id", i).attr("tgt_id", ii)
                    .attr("model1", "0")
                    .attr("model2", "0")
                    .attr("agreement", "0")
            })
        })

        svg.append("rect")
            .attr('x', x_margin + (src.length+1) * (cell_width + x_p))
            .attr('y', y_margin + (tgt.length+1) * (cell_height + y_p))
            .attr('fill', "#000")

        tgt.map((s, i) => {
            var x = x_margin + i * (cell_width + x_p) + cell_width/4
            var y = margin.top + cell_height * 0.35 + src.length * (cell_height + x_p)
            svg.append('text')
                .attr("x", x)
                .attr("y", y)
                .attr("fill", ()=>{return (search_term_language==="tgt" && s===search_term)? '#F33':"#333"})
                .attr("id", "tgt_"+ this.props.idx +"_"  + i)
                .text(s).style('text-anchor', 'start').style("font-size", "10px")
                .attr('transform', 'rotate(45 ' + x + ' ' + y + ')')
                .style('font-weight', ()=>{return (search_term_language==="tgt" && s===search_term)? '700':''});;

        })

        if(model1_name!==null) {
            model1["alignment"].map((pair) => {
                let idx = "#cell_" + this.props.idx + "_" + pair[0] + "_" + pair[1]
                var box = d3.select(idx);
                box.attr('fill', colors[model1_name])
                    .attr("fill-opacity", "1")
                    .attr("model1", "1")
                    .on("mouseover", function (d) {
                        mouseover(d, pair[0], pair[1])
                    })
                    .on("mouseleave", function (d) {
                        mouseleave(d, pair[0], pair[1])
                    });
            })
        }

        if(model2_name!==null){
            model2["alignment"].map((pair)=>{
                let idx = "#cell_" + this.props.idx +"_"  + pair[0] + "_" + pair[1]
                var box = d3.select(idx);

                box.attr('fill',  ()=>{return box.attr("model1")==="1"?intersection_color: colors[model2_name]})
                    .attr("fill-opacity","1")
                    .attr("model2", "1")
                    .attr("agreement", ()=>{return box.attr("model1")==="1"?"1": "0"})
                    //.on("mouseover", mouseover)
                    .on("mouseover", function(d){mouseover(d, pair[0], pair[1])})
                    .on("mouseleave", function(d){mouseleave(d, pair[0], pair[1])})
            })
        }


        gs.map((pair)=>{

            let idx = "#cell_" + this.props.idx +"_" + pair[0] + "_" + pair[1]
            let strokeColor = "#666666"
            var box = d3.select(idx);
            box.style("stroke", strokeColor)
                .style("stroke-width", "1")
                .on("mouseover", function(d){mouseover(d, pair[0], pair[1])})
                .on("mouseleave", function(d){mouseleave(d, pair[0], pair[1])})

            svg.append('circle')
                .attr("cx", eval(box.attr("x")) + 8)
                .attr("cy", eval(box.attr("y")) + 8)
                .attr('r', pair[2]==="s"? 4: 1.5)
                .on("mouseover", function(d){mouseover(d, pair[0], pair[1])})
                .on("mouseleave", function(d){mouseleave(d, pair[0], pair[1])})
        })
    }

    drawBarChart = ()=>{

        const {model1_name,model2, colors, models, passage, selected_metric, idx} = this.props
        const max_tp_length = Math.max(...models.map((model, i)=>{ return passage[model].stat.tp})) *1.2

        const max_value_y = {"AER": 1, "precision": 1, "recall": 1, "f1": 1,
            "pac": 1, "coverage": 1, "tp": max_tp_length}

        let margin = {top: 20, right: 10, bottom: 120, left: 40};
        let svgWidth = 350, svgHeight = 350;
        let height = svgHeight- margin.top- margin.bottom, width = svgWidth - margin.left - margin.right;

        let x = d3.scaleBand().rangeRound([0, width]).padding(0.2),
            y = d3.scaleLinear().rangeRound([height, 0]);

        x.domain(models);
        y.domain([0, max_value_y[selected_metric]]); // d3.max(sourceCount, function(d) { return d/300; })]

        // append the svg object to the body of the page
        d3.select("#barChart_"+idx).select("svg").remove();
        var svg = d3.select("#barChart_"+this.props.idx)
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");

        let parent = this;

        var xis = svg.append("g")
            .attr("class", "axis axis--x")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x).ticks(5));

        xis.selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr("transform", "rotate(-65)");

        svg.append("g")
            .attr("class", "axis axis--y")
            .attr("id", "barchart_axis_y_"+idx)
            .call(d3.axisLeft(y).ticks(5))

        d3.select("#barchart_axis_y_"+idx)
            .append("text")
            .attr("transform", "rotate(-90) translate(-"+height/2+", -30)").attr("fill", "#333")
            .text(selected_metric.toUpperCase());

        // Create rectangles
        // Drawing model 1
        let bars = svg.selectAll('.bar')
            .data(models)
            .enter()
            .append("g");

        bars.append('rect')
            .attr('class', 'bar')
            .attr("x", function(d) { return x(d); })
            .attr("y", function(d) { return y(passage[d]["stat"][selected_metric]); })
            .attr("fill", function(d) {return colors[d]})
            .attr("width", x.bandwidth())
            .attr("height", function(d) { return height - y(passage[d]["stat"][selected_metric]); })
            .on("click", (event, d)=>{
                parent.set_model2(d)
            });

        // bars.append("text")
        //     .text(function(d) {
        //         return passage[d]["stat"][selected_metric];
        //     })
        //     .attr("x", function(d){
        //         return x(d) + x.bandwidth()/2;
        //     })
        //     .attr("y", function(d){
        //         return y(passage[d]["stat"][selected_metric]) - 5;
        //     })
        //     .attr("font-family" , "sans-serif")
        //     .attr("font-size" , "10px")
        //     .attr("fill" , "black")
        //     .attr("text-anchor", "middle");

    }

    visualize_text = ()=> {

         const {model1_name, colors, idx} = this.props
         const {model2_name, src, tgt, gs, intersection_color} = this.state
         const model1 = this.props.passage[model1_name]
         const model2 = model2_name===null?null:this.props.passage[model2_name]


        // var src = ["How", "are", "you", "doing", "at", "school"]
        // var tgt = ["sein", "oder", "nicht", "sein"]



        // append the svg object to the body of the page
        d3.select("#Viz_area"+idx).select("svg").remove();
        var svg = d3.select("#Viz_area"+idx)
            .append("svg")
            .attr("width", 800)
            .attr("height", 200)
            .append("g")
            // .attr("transform",
            //     "translate(" + margin.left + "," + margin.top + ")");
        var x_padding = 8;

        let al_elements = []
        // print source sentence
        src.map((d, i) => {
            var x = 0
            if (i > 0) {
                var box = d3.select("#pv_src_"+idx+"_" + (i - 1)).node().getBBox();
                x = box['x'] + box['width'] + x_padding
            }
            svg.append('text')
                .attr("id", "pv_src_"+idx+"_"+ i)
                .attr("x", x)
                .attr("y", 10)
                .attr("fill", "#000")
                .text(d).style("font-size", "10px")
                .style('text-anchor', 'start');
        })
        // print target sentence
        tgt.map((d, i) => {
            var x = 0
            if (i > 0) {
                var box = d3.select("#pv_tgt_"+idx+"_" + (i - 1)).node().getBBox();
                x = box['x'] + box['width'] + x_padding
            }
            svg.append('text')
                .attr("id", "pv_tgt_"+idx+"_" + i)
                .attr("x", x)
                .attr("y", 100)
                .attr("fill", "#000")
                .text(d).style("font-size", "10px")
                .style('text-anchor', 'start');;
        })
      //  draw the alignments
         if(model1_name!==null){
             var al = model1["alignment"]//[[2, 1], [1, 0], [3, 2], [5, 3]]
             al_elements = model1["alignment"].map((p)=>{ return p[0] + "-" + p[1]})

             al.map((pair, i) => {
                 var box_src = d3.select("#pv_src_"+idx+"_" + pair[0]).node().getBBox();
                 var box_tgt = d3.select("#pv_tgt_"+idx+"_" + pair[1]).node().getBBox();

                 svg.append("line")
                     .attr("x1", box_src['x'] + box_src['width'] / 2)
                     .attr("y1", box_src['y'] + box_src['height'])
                     .attr("x2", box_tgt['x'] + box_tgt['width'] / 2)
                     .attr("y2", box_tgt['y'])
                     .attr("stroke-width", 2)
                     .attr("stroke", colors[model1_name]);
             })


         }

         if(model2_name!==null){
             var al2 = model2["alignment"]
             al2.map((pair, i) => {
                 var box_src = d3.select("#pv_src_"+idx+"_" + pair[0]).node().getBBox();
                 var box_tgt = d3.select("#pv_tgt_"+idx+"_" + pair[1]).node().getBBox();
                 svg.append("line")
                     .attr("x1", box_src['x'] + box_src['width'] / 2)
                     .attr("y1", box_src['y'] + box_src['height'])
                     .attr("x2", box_tgt['x'] + box_tgt['width'] / 2)
                     .attr("y2", box_tgt['y'])
                     .attr("stroke-width", 2)
                     .attr("stroke", al_elements.includes(pair[0] + "-"+ pair[1])?intersection_color: colors[model2_name] );
             })
         }

        if(this.state.gs_pv_checked){
            gs.map((pair, i) => {
                var box_src = d3.select("#pv_src_"+idx+"_" + pair[0]).node().getBBox();
                var box_tgt = d3.select("#pv_tgt_"+idx+"_" + pair[1]).node().getBBox();
                svg.append("line")
                    .attr("x1", box_src['x'] + box_src['width'] / 2)
                    .attr("y1", box_src['y'] + box_src['height'])
                    .attr("x2", box_tgt['x'] + box_tgt['width'] / 2)
                    .attr("y2", box_tgt['y'])
                    .attr("stroke-width", 2) .attr("stroke", "#999")
                    .attr("stroke-dasharray", pair[2]==="s"? ("10, 8"): ("1, 1"));
            })
        }
    }


    gs_pv_handleChange = ()=>{
        this.setState({
            gs_pv_checked: !this.state.gs_pv_checked
        })
    }
    render(){
        const {model2_name, model1_name, intersection_color, selected_view, gs_pv_checked} = this.state
        const {colors, idx, passage} = this.props
        const model1 = this.props.passage[model1_name]
        const model2 = model2_name===null?null:this.props.passage[model2_name]
        let model1_list = model1_name===null?[]:model1["alignment"].map(x=>{return x[0] + "-" + x[1]})
        let model2_list = model2_name===null?[]:passage[model2_name]["alignment"].map(x=>{return x[0] + "-" + x[1]})
        let selected_button_css = "px-2 py-1 bg-neutral-700 rounded text-xs text-white m-1 hover:text-yellow-500"
        let default_button_css = "px-2 py-1 border border-gray-300 rounded text-xs text-gray-600 m-1  hover:bg-gray-200"
        // let disabled_button_css = "px-2 py-1 border border-gray-300 rounded text-xs text-gray-600 m-1  bg-gray-200 cursor-not-allowed"
        return (

            <div key={"div_"+this.props.id}
                 className="w-full p-4 mt-3 bg-white  border border-gray-300 rounded-lg shadow-lg ">

                <div className="flex">

                    <div className="flex-1 ">
                        <h1 className="font-bold ml-2">{passage.id}</h1>
                        <div className=" mb-1">
                            <button className={selected_view==="grid"?selected_button_css:default_button_css}
                                    onClick={()=>{this.setSelectedView("grid")}}>Grid</button>
                            {/*<button className={selected_view==="pv"?selected_button_css:default_button_css}*/}
                            {/*        onClick={()=>{this.setSelectedView("pv")}}>Parallel View</button>*/}
                            <button className={selected_view==="sbs"?selected_button_css:default_button_css}
                                    onClick={()=>{this.setSelectedView("sbs")}}>Side by Side</button>
                            {model1_name===null?null:
                            <button className={selected_view==="tp"?selected_button_css:default_button_css}
                                    onClick={()=>{this.setSelectedView("tp")}}>Translation Pairs</button>}
                        </div>

                        <div id={"div_tooltip_"+idx} className="text-left">
                            {model1_name===null?null:
                            <span className="text-xs px-2 py-1 m-1 rounded text-white" style={{"backgroundColor": colors[model1_name], "fontSize": "11px"}}>
                                {model1_name}
                                <span className="bg-white text-xs m-1 rounded p-1 font-bold" style={{"color": colors[model1_name], "fontSize": "8px"}}>{passage[model1_name]["alignment"].length}</span>

                            </span>
                            }{model2_name === null ? null :
                            <span className="text-xs px-2 py-1 m-1 rounded text-white"
                                  style={{"backgroundColor": colors[model2_name], "fontSize": "11px"}}>{model2_name}
                                <span className="bg-white text-xs m-1 rounded p-1 font-bold" style={{"color": colors[model2_name], "fontSize": "8px"}}>
                                {passage[model2_name]["alignment"].length}</span>
                            </span>
                        }{model1_name === null || model2_name === null ? null :
                            <span className="text-xs px-2 py-1 m-1 rounded text-white"
                                  style={{"backgroundColor": intersection_color, "fontSize": "11px"}}>Agreement
                            <span className="bg-white text-xs m-1 rounded p-1 text-green-700 font-bold" style={{ "fontSize": "8px"}}>
                                {model2_list.filter(x=> model1_list.includes(x)).length}</span>
                            </span>
                        }
                        </div>
                        <div id={"sentenceChart_"+this.props.idx} className={selected_view!=="grid"?"hidden": ""}>
                        </div>
                        <div className={selected_view!=="pv"?"hidden": "mt-3 "} >
                            <div className="flex justify-left mb-3">
                                <div className="form-check">
                                    <input className="form-check-input appearance-none h-4 w-4 border border-gray-300
                                    rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none
                                    transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left
                                     mr-2 cursor-pointer"
                                           type="checkbox"
                                           checked={gs_pv_checked}
                                           onChange={()=>{this.gs_pv_handleChange()}}
                                           value="" id="flexCheckDefault"/>
                                        <label className="form-check-label inline-block text-gray-800 text-xs" htmlFor="flexCheckDefault">
                                            Show Gold Standard
                                        </label>
                                </div>
                            </div>
                            <div id={"Viz_area"+this.props.idx}></div>
                        </div>
                        {selected_view==="sbs"?
                            <SideBySideView src={this.state.src}
                                            tgt={this.state.tgt}
                                            alignment={model2_name===null?(model1_name===null?[]:model1["alignment"]):model2["alignment"]}
                                            idx={idx}
                                            model_name={model2_name===null?model1_name:model2_name}
                                            colors={this.props.colors}
                                            search_term={this.props.search_term}
                                            search_term_language={this.props.search_term_language}
                            />:null}
                        {selected_view==="tp"&&model1!==null?
                            model2!==null?
                                <TableTwoModels
                                    model1_name={model1_name}
                                    model2_name={model2_name}
                                    colors={this.props.colors}
                                    pairs1={model1_list}
                                    pairs2={model2_list}
                                    tokens1={this.state.src}
                                    tokens2={this.state.tgt}
                                    intersection_color={intersection_color}
                                />:
                            <Table pairs={model1.pairs} />:null}

                    </div>
                    {model1_name!=null?
                    <div id={"barChart_"+this.props.idx} className="pt-8">
                    </div>: null}
                </div>
            </div>
        )
    }
}

export default TwoModelsGridExtended;